/*
 * File: url-join.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2023-12-19 03:31:28
 * Modified By: Val Liu
 * -----
 */

const UrlJoin = require("url-join");

export namespace Url {
    export function join(...args: string[]) {
        /// remove undefined
        args = args.reduce<any[]>((final, arg) => {
            if (arg != undefined) final.push(arg);
            return final;
        }, []);
        return UrlJoin(...args);
    }
}
